import script from "./RateChip.vue?vue&type=script&setup=true&lang=js"
export * from "./RateChip.vue?vue&type=script&setup=true&lang=js"

import "./RateChip.vue?vue&type=style&index=0&id=60203a38&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60203a38"]])

export default __exports__